<div [ngClass]="{ 'disney-detail': isDisney, 'hotel-detail': !isDisney }">
  <div [ngClass]="{ 'disney-background': isDisney }">
    @if (
      hotelAvailabilityInfo?.best_room_cluster?.rates &&
      (hotelAvailabilityInfo?.best_room_cluster?.rates)[0] &&
      (hotelAvailabilityInfo?.best_room_cluster?.rates)[0]?.provider
    ) {
      <mb-badge size="small" color="light" class="provider-description">
        {{ hotelAvailabilityInfo.best_room_cluster.rates[0].provider }}
      </mb-badge>
    }

    @if (!isLanding && !busy) {
      <search-widget
        [searchedEntity]="searchedEntity"
        [section]="'detail'"
        (resetState)="onResetState()"
        [isDisney]="isDisney"
      ></search-widget>
    }

    @if (!showEmptyState) {
      <mb-tabs
        [selectedTab]="1"
        (selectedTabChange)="detailTabChange($event)" #detailTabsComp>
        <mb-tab>
          <mb-tab-title i18n="@@descripcion">DESCRIPCION</mb-tab-title>
          <mb-tab-content>
            <am-header-mobile></am-header-mobile>
            <image-message [hotelCountry]="hotelStaticInfo?.country?.id"></image-message>
            @if (hasUniversal) {
              <universal-benefits-detail [hotelId]="hotelStaticInfo?.id"></universal-benefits-detail>
            }
            @if (showAvuxi) {
              <avuxi
                type="top_locations"
                [position]="hotelPosition"
                action="show"
                [brand]="brand"
              ></avuxi>
            }
            <div class="mb-container-full mb-grid-row flex-column content-des">
              <div class="content-description mb-container-full mb-grid-row ">
                @if (isDisney && showBenefit) {
                  <am-disney-benefits class="mb-grid-col-4 "></am-disney-benefits>
                }
                @if (hotelStaticInfo?.amenities) {
                  <amenities
                    [isDisney]="isDisney"
                    [amenities]="hotelStaticInfo?.amenities"
                    class="mb-grid-col-4 ctn-description first-element last-element"
                  ></amenities>
                }
                <check-times
                  [staticInfo]="hotelStaticInfo"
                  [mobile]="true"
                  style="width:100% ;"
                  class="mb-grid-col-4 ctn-description"
                ></check-times>
                @if (
                  hotelStaticInfo?.description &&
                  hotelStaticInfo?.description?.hotel_description?.length > 0
                ) {
                  <description
                    class="mb-grid-col-4 ctn-description"
                    [description]="hotelStaticInfo?.description"
                    [hotelStatic]="hotelStaticInfo"
                    [isLanding]="isLanding"
                    [additionalInfos]="hotelStaticInfo?.additional_infos"
                  ></description>
                }
                @if (isDisney) {
                  <cancel-policies
                    class="mb-grid-col-4 ctn-description"
                    [isDisney]="isDisney"
                    [countryId]="hotelStaticInfo?.country?.id"
                  ></cancel-policies>
                  <activities-information-disney class="mb-grid-col-4 ctn-description"></activities-information-disney>
                  <parking-disney class="mb-grid-col-4 ctn-description"></parking-disney>
                }
                @if (comments) {
                  <am-comments
                    class="mb-grid-col-4 ctn-description"
                    [comments]="comments"
                  ></am-comments>
                }
              </div>
            </div>
          </mb-tab-content>
        </mb-tab>
        @if ((!error && !busy) || (loading$ | async)) {
          <mb-tab [disabled]="loading$ | async">
            <mb-tab-title i18n="@@habitaciones">HABITACIONES</mb-tab-title>
            <mb-tab-content>
              <am-header-mobile></am-header-mobile>
              <div class="room-filter-wrapper">
                <am-room-filters-responsive></am-room-filters-responsive>
              </div>
              @if ((loading$ | async) && busy) {
                <loader-detail></loader-detail>
              }
              @if (
                !hotelAvailabilityInfo?.best_room_cluster &&
                !hotelAvailabilityInfo?.best_disney_room_cluster &&
                !busy
              ) {
                <div class="unavailable-content">
                  @if (isLanding) {
                    <div class="alert-description">
                      <strong>Ingresa las fechas</strong> de tu estadía para ver los precios de
                      las habitaciones
                    </div>
                    <search-widget
                      [searchedEntity]="searchedEntity"
                      [section]="'detail'"
                      (resetState)="onResetState()"
                      [isDisney]="isDisney"
                      [buttonMode]="true"
                    ></search-widget>
                  } @else {
                    <div class="alert-description">
                      Uy, no hay disponibilidad. Podés probar otras fechas.
                    </div>
                    <search-widget
                      id="more-rooms"
                      [searchedEntity]="searchedEntity"
                      [section]="'detail'"
                      (resetState)="onResetState()"
                      [isDisney]="isDisney"
                      [buttonMode]="true"
                    ></search-widget>
                  }
                </div>
              }
              @if (!isLanding && !(loading$ | async)) {
                <div
                  id="rooms"
                  class="container-component"
                  [ngClass]="{'container-component--disney': isDisney}">
                  @for (cluster of (roomClusters$ | async) ?? []; track cluster) {
                    <div class="room-cluster-wrapper">
                      <am-room-summary
                        [room]="cluster"
                        [expanded]="expandablePanel.expanded()"
                        (clickIcon)="expandablePanel.toggle()">
                      </am-room-summary>
                      <mb-expandable-panel #expandablePanel>
                        @if (!isDisney) {
                          @for (rate of cluster.rates; track $index) {
                            <am-rate-detail [rate]="rate" [elevation]="$index + 1"></am-rate-detail>
                          }
                        } @else {
                          <am-rate-detail [disneyCluster]="cluster"></am-rate-detail>
                        }
                      </mb-expandable-panel>
                    </div>
                  }
                  @if (areThereMoreRooms$ | async) {
                    <div class="show-more-rooms" (click)="showMoreRooms()">
                      <span>
                        Ver más habitaciones
                      </span>
                      <mb-icon icon="add"></mb-icon>
                    </div>
                  }
                </div>
              }
              @if (
                hotelStaticInfo?.description?.room_fees_description ||
                hotelStaticInfo?.description?.mandatory_fees_description
              ) {
                <div class="container-component">
                  <div class="mb-container-full">
                    <div class="am-ctn mb-container-full mb-grid-row container-services">
                      <services
                        [services]="hotelStaticInfo?.description"
                        class="am-ctn--gtr-inside mb-grid-col-4"
                      ></services>
                    </div>
                  </div>
                </div>
              }
            </mb-tab-content>
          </mb-tab>
        }
        @if ((!error && tabComments) || (loading$ | async)) {
          <mb-tab [disabled]="loading$ | async">
            <mb-tab-title i18n="@@opiniones">OPINIONES</mb-tab-title>
            <mb-tab-content>
              @if (tabComments) {
                <am-experts-review-carousel
                  #expertsCarousel
                  [productId]="hotelStaticInfo.id"
                  [productType]="'HOTEL'"
                ></am-experts-review-carousel>
                <tripadvisor-reviews [data]="hotelStaticInfo"></tripadvisor-reviews>
              }
            </mb-tab-content>
          </mb-tab>
        }
        @if ((!error && tabRelated) || (loading$ | async)) {
          <mb-tab [disabled]="loading$ | async">
            <mb-tab-title i18n="@@ofertas_similares">OFERTAS SIMILARES</mb-tab-title>
            <mb-tab-content>
              @if (tabRelated) {
                <related-hotels
                  [name]="hotelStaticInfo?.name"
                  [related]="recommendedHotels"
                  [priceByValue]="priceByValue"
                  [showAmountTotal]="hotelAvailabilityInfo?.show_amount_total"
                  [section]="'Detail'"
                  [isLanding]="isLanding"
                  [hotelCountry]="hotelStaticInfo?.country?.id"
                  [hotelCity]="hotelStaticInfo?.city?.id"
                ></related-hotels>
              }
            </mb-tab-content>
          </mb-tab>
        }
      </mb-tabs>
    } @else {
      <div class="mb-grid-container-full empty-state-wrapper">
        <div class="title">
          <p>{{ emptyStateLabel }}</p>
        </div>
        <div class="subtitle">
          <p>Probá cambiando el tipo de moneda a $ Pesos Argentinos</p>
        </div>
        <div class="facture">
          <div class="svg-facture"></div>
        </div>
        <div class="actionable-btn-wrapper">
          <button mb-button variant="outline" color="primary" (click)="onResetState('ARS')">BUSCAR EN $ PESOS</button>
        </div>
      </div>
    }

    @if (selectedTab === 0 || selectedTab === 3) {
      <price-box-mobile
        (selectTab)="selectTab($event)"
        [hotelStatic]="hotelStaticInfo"
        [bestAvailable]="bestAvailable"
        [busy]="busy"
        [isLanding]="isLanding"
        [priceByValue]="priceByValue"
        [showAmountTotal]="hotelAvailabilityInfo?.show_amount_total"
        [isDisney]="isDisney"
      ></price-box-mobile>
    }
  </div>
</div>
